import './BiosecurityWebSeries.css'
import Webinars from "./Webinars";
import webinar_img1 from "../photos/farm-animals1.jpeg";
import webinar1_pdf from "./Resources/Webinar 1_FARM PPE.pdf";
import FirstWebinarResource from "./Resources/FirstWebinarResource";
import webinar_img2 from "../photos/farm-animals2.jpeg";
import webinar2_pdf from "./Resources/Webinar 2_FARM PPE.pdf";
import SecondWebinarResource from "./Resources/SecondWebinarResource";
import webinar_img3 from "../photos/farm-animals3.jpeg";
import webinar3_pdf from "./Resources/Webinar 3_FARM PPE.pdf";
import ThirdWebinarResource from "./Resources/ThirdWebinarResource";
import webinar_img4 from "../photos/farm-animals4.jpeg";
import webinar4_pdf from "./Resources/Webinar 4_FARM PPE.pdf";
import FourthWebinarResource from "./Resources/FourthWebinarResource";
import webinar_img5 from "../photos/farm-animals5.jpeg";
import webinar5_pdf from "./Resources/Webinar 5_FARM PPE.pdf";
import FifthWebinarResource from "./Resources/FifthWebinarResource";
import webinar_img6 from "../photos/farm-animals6.jpeg";
import webinar6_pdf from "./Resources/Webinar 6_FARM PPE.pdf";
import SixthWebinarResource from "./Resources/SixthWebinarResource";
import webinar_img7 from "../photos/farm-animals7.jpeg";
import webinar7_pdf from "./Resources/Webinar 7_FARM PPE.pdf";
import SeventhWebinarResource from "./Resources/SeventhWebinarResource";

import webinar8_pdf from './Resources/Webinar 8_FARM PPE.pdf'
import webinar_img8 from "../photos/farm-animals8.jpeg";

const BiosecurityWebSeries = () => {
    return (
        <div className= 'webinar-series' id ="biosecurity-webinars">
        <h1 className= 'series-title' > Biosecurity Webinar Series </h1>
        <p className= 'series-notice'> Fill out all eight post-webinar surveys by <span style = {{color : "#f7c35f"}}> Tuesday May 31st, 2022 </span> to receive a certificate of attendance for the course! </p>
        <div className= 'series-content' id = 'biosecurity-webinars-content'>
            <Webinars img = {webinar_img1} date = "04 Jan"
                      title = "Webinar 1: Course Introduction & General Biosecurity Principles"
                      recording_link = "https://youtu.be/_SDrvl9AsEg"
                      survey_link = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_5ak07YXV25DI7LE"
                      presentation_slides = {webinar1_pdf}
                      resources = {<FirstWebinarResource/>}
            />
            <Webinars img = {webinar_img2} date = "11 Jan"
                      title = "Webinar 2: Mapping Your Farm & Equipment and Vehicles"
                      recording_link = "https://youtu.be/rPEaFL_87Mk"
                      survey_link = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_d4FGwqMqOL6ZZ8q"
                      presentation_slides = {webinar2_pdf}
                      resources = {<SecondWebinarResource/>}
            />
            <Webinars img = {webinar_img3} date = "18 Jan"
                      title = "Webinar 3: Visitors (Humans, Vectors, Rodents, Birds, Wildlife)"
                      recording_link = "https://youtu.be/BSS2-6t4Qys"
                      survey_link = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_b7rhGCoyWJt1fxQ"
                      presentation_slides = {webinar3_pdf}
                      resources = {<ThirdWebinarResource/>}
            />
            <Webinars img = {webinar_img4} date = "25 Jan"
                      title = "Webinar 4: Keep it Clean"
                      recording_link = "https://youtu.be/WOuEcWArIV0"
                      survey_link = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_eXuA9ZrI2EJdpIy"
                      presentation_slides = {webinar4_pdf}
                      resources = {<FourthWebinarResource/>}
            />
            <Webinars img = {webinar_img5} date = "Feb 01"
                      title = "Webinar 5: Animal Health & Welfare"
                      recording_link = "https://youtu.be/0QZ5vPEr8k8"
                      survey_link = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_9LJagX8QggPfeK2"
                      presentation_slides = {webinar5_pdf}
                      resources = {<FifthWebinarResource/>}
            />
            <Webinars img = {webinar_img6} date = "Feb 08"
                      title = "Webinar 6: Zoonoses"
                      recording_link = "https://youtu.be/5joB9D5ZAwI"
                      survey_link = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_269xk2ktIRXsYD4"
                      presentation_slides = {webinar6_pdf}
                      resources = {<SixthWebinarResource/>}
            />
            <Webinars img = {webinar_img7} date = "Feb 15"
                      title = "Webinar 7: Carcass Management & Disposal"
                      recording_link = "https://youtu.be/ufDRDQ7CZeM"
                      survey_link = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_9Nzb9JpoJ3ovEh0"
                      presentation_slides = {webinar7_pdf}
                      resources = {<SeventhWebinarResource/>}
            />

            <Webinars img = {webinar_img8} date = "01 Mar"
                      title = "Webinar 8: Biosecurity Template Overview & Walk-through"
                      recording_link = "https://youtu.be/1xjwLAKQFQY"
                      survey_link = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_cwkvDa01C9hH422"
                      presentation_slides = {webinar8_pdf}
            />

        </div>
    </div>
    )
}

export default BiosecurityWebSeries;